import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function Yoili({ config }) {
  return (
    <section
      className="relative bg-black text-white py-24 md:py-36 border-t border-white/10 overflow-hidden"
      data-testid="yoili-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-center">
          <div className="col-span-12 md:col-span-7">
            <div className="eyebrow mb-6">§ Sister Brand</div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="font-serif text-5xl sm:text-7xl md:text-9xl leading-[0.85] tracking-tight"
            >
              You Own It.
              <br />
              <span className="italic text-zinc-400">Live It.</span>
            </motion.h2>
            <p className="mt-8 max-w-lg text-zinc-400 text-base md:text-lg leading-relaxed">
              YOILI Designs grew from Yolanda's creative passion for meaningful jewelry and adornments — an extension of the same philosophy that shapes every appointment inside the studio.
            </p>
            <a
              href={config.yoili_url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-3 group"
              data-testid="yoili-cta"
            >
              <span className="font-mono uppercase tracking-[0.22em] text-xs">
                Explore YOILI Designs
              </span>
              <span className="w-10 h-10 rounded-full border border-white/40 flex items-center justify-center group-hover:bg-white group-hover:text-black transition-colors">
                <ArrowUpRight className="w-4 h-4" strokeWidth={1.4} />
              </span>
            </a>
          </div>

          <div className="col-span-12 md:col-span-5">
            <div className="relative aspect-square w-full">
              <div className="absolute inset-0 rounded-full border border-white/15" />
              <div className="absolute inset-6 rounded-full border border-white/10" />
              <div className="absolute inset-12 rounded-full border border-white/5" />
              <div className="absolute inset-0 flex items-center justify-center text-center">
                <div>
                  <div className="font-serif text-7xl md:text-9xl leading-none">Y.</div>
                  <div className="eyebrow mt-4 text-zinc-500">YOILI · Designs</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
